<template>
<header
	data-component="DesktopNavbar.vue"
	class="global-navigation | sticky inset-x-0 top-0 z-48 border-b border-black/10 bg-white"
	style="z-index: 65;"
>
	<div
		data-component="BuyerViewDesktopNavigation.vue"
		class="[ buyer-view-desktop-navigation ] container mx-auto flex items-center justify-between"
	>
		<a href="/" class="svg svg-logotype-oferteo" @click.prevent="GoTo('travelTo', 'HomePage', 'HomePage')">Oferteo.pl</a>
		<div class="flex items-center">
			<button class="btn btn-primary btn-small mr-10" data-test="buyer__add_order_btn" @click.prevent="GoTo('travelTo', 'HomePage', 'HomePage')">
				Dodaj zlecenie
			</button>
			<a
				class="mr-10 flex h-20 items-center border-b-2 border-transparent transition-all hover:text-accent"
				:class="{ '!border-accent font-bold !text-accent': $route.meta.isRfpsMenuItemActive }"
				data-test="buyer__my_orders_btn"
				@click.prevent="GoTo('routerName', 'BuyerList', 'BuyerList')"
			>Moje zlecenia</a>
			<DropdownPanel v-if="userStore.role === 'BUYER'" ref="BuyerDropdown" class="global-notifications | mr-10" title="Powiadomienia" Direction="bottom right">
				<template #button>
					<div class="buyer-ring-bell | relative top-1 flex text-neutral-700 hover:text-accent">
						<OIcon name="bell" size="1.25" data-test="notification_bell"/>
						<div v-if="isBellRinging" class="bg-danger-design absolute right-0.5 top-0 -m-0.5 size-[10px] rounded-full border border-white"/>
					</div>
				</template>
				<BuyerMessages @close-dropdown="$refs.BuyerDropdown?.Toggle(false)"/>
			</DropdownPanel>
			<a
				v-if="userStore.isAuth"
				class="flex h-20 items-center border-b-2 border-transparent transition-all hover:text-accent"
				:class="{ '!border-accent font-bold !text-accent': $route.meta.isProfilesMenuItemActive }"
				data-test="buyer__my_profile_btn"
				@click.prevent="GoToProfile"
			>Mój profil</a>
		</div>
	</div>
</header>
</template>

<script lang="ts">
import { mapState, mapStores } from 'pinia';
import { useUserStore } from '@globals/stores/user';
import DropdownPanel from '../global/DropdownPanel.vue';
import BuyerMessages from '../../../app-buyer/buyer-view/BuyerMessages.vue';
import { useBuyerMessagesStore } from '@buyer/stores/buyerMessagesStore';

export default {
	name: 'BuyerViewDesktopNavigation',
	components: {
		DropdownPanel,
		BuyerMessages,
	},
	emits: ['handle-menu-travel'],
	computed: {
		...mapStores(useUserStore),
		...mapState(useBuyerMessagesStore, ['isBellRinging']),
	},
	methods: {
		GoToNotifications() {
			this.$router.push({ name: 'BuyerMessagesPage' });
		},
		GoTo(action: string, value: string, label: string) {
			if (this.Analytics) {
				this.Analytics.sendGAEvent('navbar_click', { label });
			}

			if (action === 'travelTo' && value === 'HomePage') {
				document.location.href = '/';
				return;
			}

			this.$router.push({ name: value });
			return;
		},
		GoToProfile() {
			if (this.userStore.role === 'BUYER') {
				this.$router.push({ name: 'BuyerContactData' });
			} else {
				window.location.href = '/konto/profil/informacje';
			}
		},
	},
};
</script>

<style lang="scss">
.global-notifications .dropdown-panel {
	top: 2.5rem;
	width: 37.5rem;
	padding: 0;
	margin-right: -8rem;
}
</style>
